import { CALL_SOURCE } from 'utils/enums';

export const CALL_SOURCE_OPTION = {
  [CALL_SOURCE.VNPT]: {
    tagStye: {
      backgroundColor: '#ffff',
      borderColor: '#1564E8',
      color: '#1564E8'
    }
  },
  [CALL_SOURCE.APP]: {
    tagStye: {
      backgroundColor: '#D1131D',
      borderColor: '#D1131D',
      color: '#FFFFFF'
    }
  },
  [CALL_SOURCE.WEB]: {
    tagStye: {
      backgroundColor: '#1564E8',
      borderColor: '#1564E8',
      color: '#FFFFFF'
    }
  }
};
